const API_ROUTE = process.env.VUE_APP_API_ROUTE

// const ARQUEO = API_ROUTE + "/arqueo"
const POS_DAILY_CASH_INITIAL_RESUME = API_ROUTE + '/pos_daily_cash_initial_resume'
const POS_DAILY_CASH_COMPLETE_RESUME = API_ROUTE + '/pos_daily_cash_complete_resume'
const SALE_CUSTOMER = API_ROUTE + '/pos_sale/pay'
const SALE_EMPLOYEE = API_ROUTE + '/pos_employee_sale/pay'
const SALE_CUSTOMER_MULTIPLE = API_ROUTE + '/pay_multiple_sales'
const DAILY_CASH = API_ROUTE + '/pos_daily_cash'
const DAILY_CLOSE = API_ROUTE + '/pos_daily_cash_close'

//const DAILY_INVOICES = API_ROUTE + '/get_last_sale_invoice_open_cash_desk'
const DAILY_INVOICES = API_ROUTE + '/get_last_sale_invoice_open_cash_desk'
const CASH_MOV = API_ROUTE + '/pos_cash_movement'
const INGRESS_TYPES = API_ROUTE + '/pos_cash_movement_ingress_type'
const EGRESS_TYPES = API_ROUTE + '/pos_cash_movement_egress_type'

const SEARCH_TICKET = API_ROUTE+'/dte/number/'
const GENERATE_SALE = API_ROUTE +'/sl_service_order/cancel'
const GET_BANKS = API_ROUTE + '/g_bank?get_all_results=true'

const AUTH_UNIQUE_KEY = API_ROUTE + '/bar_authorization'
// GModule
const GET_LOGIN_MODULE_DATA = API_ROUTE + '/get_login_module'
// Auth token
const GET_LOGIN_TOKEN = API_ROUTE + '/auth/get_login_token'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'

//check New totals multiplePayments
const GET_NEW_TOTALS = API_ROUTE + '/pos_sale/multiple_payments/get_new_totals'
const TICKET_NEXT = API_ROUTE + '/sl_service_order/ticket_next'
export default {
    SALE_CUSTOMER,
    SALE_EMPLOYEE,
    DAILY_CASH,
    DAILY_CLOSE,
    CASH_MOV,
    SEARCH_TICKET,
    GENERATE_SALE,
    POS_DAILY_CASH_INITIAL_RESUME,
    POS_DAILY_CASH_COMPLETE_RESUME,
    AUTH_UNIQUE_KEY,
    DAILY_INVOICES,
    GET_BANKS,
    INGRESS_TYPES,
    EGRESS_TYPES,
    GET_LOGIN_MODULE_DATA,
    GET_LOGIN_TOKEN,
    LOGOUT_REQUEST,
    SALE_CUSTOMER_MULTIPLE,
    GET_NEW_TOTALS,
    TICKET_NEXT,
}